module.exports = __webpack_public_path__ + "static/media/mandibular-tornillos.b7c18f28.png";